module.exports = __webpack_public_path__ + "static/media/sm.12256dfd.png";